import ConfirmAlertDialog from '../dialogs/confirm-alert';
import {Button} from '@mui/material';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';
import {useMutationAsUser, useMutationCoordinate} from '../../clients/graphql/graphql.hooks';
import {deleteAutoPilotSettingsMutation} from '../../clients/graphql/components/buttons-queries';

export interface DeleteAutoPilotSettingsProps {
  autoPilotSettingsKey: number
  userKey: number
}

export function DeleteAutoPilotSettingsButton({ autoPilotSettingsKey, userKey }: DeleteAutoPilotSettingsProps) {

  const [deleteAPSettings, deleteResponse] = useMutationAsUser(deleteAutoPilotSettingsMutation, { userKey: userKey, variables: { autoPilotSettingsKey: autoPilotSettingsKey }})

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <ConfirmAlertDialog
        title='Are you sure you want to delete the Pilot?'
        description='Deleting Pilot'
        actionButtonTitle='Delete Pilot'
        onConfirm={() => deleteAPSettings()}
        buttonComponent={
          <Button
            component="a"
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            size={'small'}
            color={'error'}
          >
            Delete Pilot
          </Button>
        }
      />

      {deleteResponse?.data?.autoPilotSettings?.setupStatus === 'DELETED' && (
          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success" sx={{marginTop: '10px', width: "300px"}} variant="outlined" >
            Pilot Deleted
          </Alert>
        )
      }

      {deleteResponse?.data?.autoPilotSettings?.setupStatus !== undefined &&
        deleteResponse?.data?.autoPilotSettings?.setupStatus !== 'DELETED' && (
          <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error" sx={{marginTop: '10px', width: "300px"}} variant="outlined" >
            There was an error with the delete request - try again later
          </Alert>
        )
      }
    </div>
  )
}